import { AxiosPromise } from 'axios';
import { apis } from 'probonio-shared-ui/module/api';

export type BikeleasingContractDocumentType = 'elv' | 'transferAgreement';

interface BikeleasingContractDocumentParams {
  tenantId: string;
  contractId: string;
}

interface BikeleasingContractDocumentConfig {
  label: string;
  notAvailable: string;
  downloadError: string;
  /**
   * Only applies when the response carries no Content-Disposition at all. Mirrors CONTRACT_DOCUMENTS in
   * the API's bikeleasing.provider.ts — without it both documents would be saved as contract.pdf.
   */
  defaultFileName: string;
  headFile: (params: BikeleasingContractDocumentParams) => AxiosPromise<void>;
  downloadFile: (params: BikeleasingContractDocumentParams) => AxiosPromise<Blob>;
}

/**
 * Single source for everything that differs between the two contract documents, so that a third document type
 * only has to be added here.
 *
 * The api calls are wrapped rather than referenced directly: apis.bikeLeasingV2 is replaced whenever the api
 * configuration changes (see APILoader) and the generated methods need their `this`, so a bare method reference
 * would break on both counts.
 */
export const CONTRACT_DOCUMENTS: Record<BikeleasingContractDocumentType, BikeleasingContractDocumentConfig> = {
  elv: {
    label: 'bikeleasing_v2.contract.documents.elv',
    notAvailable: 'bikeleasing_v2.contract.documents.elvNotAvailable',
    downloadError: 'bikeleasing_v2.contract.documents.elvDownloadError',
    defaultFileName: 'elv.pdf',
    headFile: params => apis.bikeLeasingV2.headContractElvFile(params),
    downloadFile: params => apis.bikeLeasingV2.downloadContractElvFile(params, { responseType: 'blob' }),
  },
  transferAgreement: {
    label: 'bikeleasing_v2.contract.documents.transferAgreement',
    notAvailable: 'bikeleasing_v2.contract.documents.transferAgreementNotAvailable',
    downloadError: 'bikeleasing_v2.contract.documents.transferAgreementDownloadError',
    defaultFileName: 'contract.pdf',
    headFile: params => apis.bikeLeasingV2.headContractFile(params),
    downloadFile: params => apis.bikeLeasingV2.downloadContractFile(params, { responseType: 'blob' }),
  },
};
